// extracted by mini-css-extract-plugin
export default {"date-time-picker":"date-time-picker2_date-time-picker__IE5h2"};